
import { supabase } from '@/lib/supabase';
import { PropBot } from '@/types/prop-bots';
import { findLinkedBotInfo } from '@/services/shadow-bot-utils';

export const fetchPropBotDetail = async (botId: string): Promise<PropBot | null> => {
  // First, determine if this is a shadow bot and find the original bot ID
  const linkedInfo = await findLinkedBotInfo(botId);
  const originalBotId = linkedInfo.currentBotType === 'shadow' ? linkedInfo.linkedBotId : botId;
  
  // If we can't find the original bot, fall back to the current bot
  const queryBotId = originalBotId || botId;
  
  const { data, error } = await supabase
    .from('bots')
    .select(`
      *,
      propDetails:bot_prop_details(*)
    `)
    .eq('id', queryBotId)
    .eq('type', 'prop_bot')
    .single();

  console.log('🔍 Prop Bot Detail Query Result:', {
    botId: queryBotId,
    hasData: !!data,
    propDetailsType: Array.isArray(data?.propDetails) ? 'array' : typeof data?.propDetails,
    propDetailsLength: Array.isArray(data?.propDetails) ? data.propDetails.length : 'N/A',
    propFirm: data?.propDetails?.[0]?.prop_firm || 'MISSING',
    minCapital: data?.propDetails?.[0]?.min_capital || 'MISSING'
  });

  if (error) throw error;
  
  // If we queried the original bot but need to return the shadow bot data,
  // we need to get the shadow bot's basic info but keep the original's propDetails
  if (originalBotId && originalBotId !== botId) {
    const { data: shadowBot, error: shadowError } = await supabase
      .from('bots')
      .select('*')
      .eq('id', botId)
      .single();
    
    if (shadowError) throw shadowError;
    
    // Combine shadow bot data with original bot's propDetails
    return {
      ...shadowBot,
      propDetails: data?.propDetails
    };
  }
  
  return data;
};
